/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Success_TitleInputs */

const en_contact_success_title = /** @type {(inputs: Contact_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message sent`)
};

/**
* | output |
* | --- |
* | "Message sent" |
*
* @param {Contact_Success_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_success_title = /** @type {((inputs?: Contact_Success_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Success_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_success_title(inputs)
});